import { render, staticRenderFns } from "./translateModal.vue?vue&type=template&id=703799ae&scoped=true"
import script from "./translateModal.vue?vue&type=script&lang=js"
export * from "./translateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703799ae",
  null
  
)

export default component.exports